import { useState } from 'react';
import { Collapse } from '@mui/material';
import { FiChevronDown, FiChevronUp } from 'react-icons/fi';
import {
    EmptyFilterHint,
    FilterBlock,
    FilterBlockHeader,
    FilterOption,
    OptionCount,
    ShowMoreButton,
} from './catalogStyles';

const DEFAULT_VISIBLE = 5;

/**
 * Bloco de filtro da sidebar: título colapsável + lista de checkboxes com
 * contagem. `options` são `{ value, label, count }` e `selected` é a lista de
 * valores marcados (comparada como string para tolerar id numérico vs texto).
 */
export const FilterSection = ({ title, options, selected, onToggle, emptyHint }) => {
    const [open, setOpen] = useState(true);
    const [expanded, setExpanded] = useState(false);

    const selectedKeys = new Set((selected ?? []).map(String));
    const visibleOptions = expanded ? options : options.slice(0, DEFAULT_VISIBLE);
    const hiddenCount = options.length - visibleOptions.length;

    return (
        <FilterBlock>
            <FilterBlockHeader
                type="button"
                onClick={() => setOpen((value) => !value)}
                aria-expanded={open}
            >
                {title}
                {open ? <FiChevronUp /> : <FiChevronDown />}
            </FilterBlockHeader>
            <Collapse in={open} timeout={180} unmountOnExit>
                <div>
                    {options.length === 0 ? (
                        <EmptyFilterHint>{emptyHint}</EmptyFilterHint>
                    ) : (
                        <>
                            {visibleOptions.map((option) => (
                                <FilterOption key={option.value}>
                                    <input
                                        type="checkbox"
                                        checked={selectedKeys.has(String(option.value))}
                                        onChange={() => onToggle(option.value)}
                                    />
                                    <span>
                                        {option.label}
                                        {option.count ? (
                                            <OptionCount> ({option.count})</OptionCount>
                                        ) : null}
                                    </span>
                                </FilterOption>
                            ))}
                            {hiddenCount > 0 && (
                                <ShowMoreButton type="button" onClick={() => setExpanded(true)}>
                                    + Ver mais ({hiddenCount})
                                </ShowMoreButton>
                            )}
                            {expanded && options.length > DEFAULT_VISIBLE && (
                                <ShowMoreButton type="button" onClick={() => setExpanded(false)}>
                                    Ver menos
                                </ShowMoreButton>
                            )}
                        </>
                    )}
                </div>
            </Collapse>
        </FilterBlock>
    );
};
